import { IconName } from 'dap-ui-library';

export interface Bullet {
  translationKey: string;
  icon: IconName;
}

function iterate(times: number): undefined[] {
  return new Array(times).fill(undefined);
}

export const generateBullets = (translationKey: string, count: number): Bullet[] =>
  iterate(count).map((_, index) => ({
    translationKey: `${translationKey}.${index}`,
    icon: 'check',
  }));

export const generateBulletsWithIcons = (translationKey: string, icons: IconName[]): Bullet[] =>
  icons.map((icon, index) => ({
    translationKey: `${translationKey}.${index}`,
    icon,
  }));
